import { ImpactAssessment4 } from "./impact-assessment4";

export class UpdateImpactAssessmentT4Model {
    impactAssessment: ImpactAssessment4;
    isAssessmentStatus: boolean;
    isAssessor: boolean;
    isSendNotification:boolean;

    constructor() {
        this.impactAssessment = new ImpactAssessment4();
        this.isAssessmentStatus = false;
        this.isAssessor = false;
        this.isSendNotification = false;
    }
}